import React from 'react';
import { Card, CardContent } from './ui/Card';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/Carousel';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Maria G.',
    neighborhood: 'Horizon City',
    quote: 'Comfy Clean Co. has been a lifesaver. They are always on time, incredibly thorough, and the fact that they are bilingual makes communicating so easy for my parents. Highly recommend!',
    rating: 5
  }, {
    name: 'David R.',
    neighborhood: 'Far East El Paso',
    quote: 'We hired them for our small office and the difference is night and day. Professional, quiet, and they leave the place spotless. Best cleaning service we have used.',
    rating: 5
  }, {
    name: 'Elena S.',
    neighborhood: 'Socorro',
    quote: 'I love coming home on cleaning day. The house smells so fresh and they pay attention to all the little details. It feels like a brand new home every time.',
    rating: 5
  }, {
    name: 'Michael T.',
    neighborhood: 'Clint',
    quote: 'Reliable is the perfect word. They never cancel last minute and the quality is consistently excellent. Great local business.',
    rating: 5
  }];
  return <section className="py-20 md:py-28 bg-[#FBFCFB] overflow-hidden" data-id="element-280">
      <div className="container mx-auto px-4" data-id="element-281">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-282">
          <span className="text-brand-green font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-283">
            What Our Clients Say
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy" data-id="element-284">
            Loved by El Paso Families and Businesses
          </h2>
        </div>

        <div className="max-w-5xl mx-auto relative px-4 md:px-12" data-id="element-285">
          <Carousel opts={{
          align: 'start',
          loop: true
        }} className="w-full" data-id="element-286">
            <CarouselContent className="-ml-4 md:-ml-6" data-id="element-287">
              {reviews.map((review, index) => <CarouselItem key={index} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3" data-id="element-288">
                  <Card className="border-0 shadow-sm bg-white rounded-2xl h-full" data-id="element-289">
                    <CardContent className="p-8 flex flex-col h-full" data-id="element-290">
                      <div className="flex mb-6" data-id="element-291">
                        {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-292" />)}
                      </div>
                      <p className="text-gray-700 font-body text-lg leading-relaxed mb-8 flex-grow" data-id="element-293">
                        "{review.quote}"
                      </p>
                      <div data-id="element-294">
                        <p className="font-heading font-bold text-gray-900 text-lg" data-id="element-295">
                          {review.name}
                        </p>
                        <p className="text-brand-green font-medium text-sm" data-id="element-296">
                          {review.neighborhood}
                        </p>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block" data-id="element-297">
              <CarouselPrevious className="-left-12 bg-white border-gray-200 text-brand-navy hover:bg-brand-navy hover:text-white" data-id="element-298" />
              <CarouselNext className="-right-12 bg-white border-gray-200 text-brand-navy hover:bg-brand-navy hover:text-white" data-id="element-299" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}